import React, {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import useApiStable from "../../utils/useApiStable";

const InvitationPage = () => {
    const {token} = useParams();
    const {user} = useAuth();
    const api = useApiStable();
    const navigate = useNavigate();

    const [invitation, setInvitation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [accepting, setAccepting] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const loadInvitation = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.get(`/tournaments/invitations/${token}`);
            setInvitation(data);
        } catch (err) {
            setError(err.message || "Einladung nicht gefunden oder ungültig.");
        } finally {
            setLoading(false);
        }
    }, [api, token]);

    useEffect(() => {
        loadInvitation();
    }, [loadInvitation]);

    const handleAccept = async () => {
        setAccepting(true);
        setError(null);
        try {
            await api.post(`/tournaments/invitations/${token}/accept`);
            setAccepted(true);
            setTimeout(() => navigate(`/tournaments?tournamentId=${invitation.tournamentId}`), 2000);
        } catch (err) {
            setError(err.message || "Einladung konnte nicht angenommen werden.");
        } finally {
            setAccepting(false);
        }
    };

    const handleLoginRedirect = () => {
        navigate(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
    };

    if (loading) {
        return (
            <div style={{maxWidth: 480, margin: "60px auto", padding: "0 16px"}}>
                <p>Lade Einladung...</p>
            </div>
        );
    }

    if (error && !invitation) {
        return (
            <div style={{maxWidth: 480, margin: "60px auto", padding: "0 16px"}}>
                <h2>Einladung ungültig</h2>
                <p style={{color: "#c00"}}>{error}</p>
            </div>
        );
    }

    if (accepted) {
        return (
            <div style={{maxWidth: 480, margin: "60px auto", padding: "0 16px"}}>
                <h2>Erfolgreich angemeldet!</h2>
                <p>Sie wurden gemeinsam mit {invitation.invitedByName} für das Turnier "{invitation.tournamentName}" angemeldet.</p>
                <p style={{color: "#888", fontSize: 13}}>Sie werden gleich weitergeleitet...</p>
            </div>
        );
    }

    return (
        <div style={{maxWidth: 480, margin: "60px auto", padding: "0 16px"}}>
            <h2>Einladung zum Doppelturnier</h2>
            <div style={{
                border: "1px solid #ddd",
                borderRadius: 8,
                padding: 20,
                marginBottom: 20,
                backgroundColor: "#fafafa",
            }}>
                <p><strong>Turnier:</strong> {invitation.tournamentName}</p>
                <p><strong>Eingeladen von:</strong> {invitation.invitedByName}</p>
                {invitation.registrationDeadline && (
                    <p><strong>Meldeschluss:</strong> {invitation.registrationDeadline}</p>
                )}
                {invitation.alreadyAccepted && (
                    <p style={{color: "#c00"}}>Diese Einladung wurde bereits angenommen.</p>
                )}
                {!invitation.registrationOpen && (
                    <p style={{color: "#c00"}}>Die Anmeldefrist für dieses Turnier ist abgelaufen.</p>
                )}
            </div>

            {error && <p style={{color: "#c00", marginBottom: 12}}>{error}</p>}

            {!user && (
                <div>
                    <p>Um die Einladung anzunehmen, müssen Sie sich anmelden oder registrieren.</p>
                    <button
                        onClick={handleLoginRedirect}
                        style={{padding: "8px 20px", fontSize: 15, cursor: "pointer"}}
                    >
                        Zum Login
                    </button>
                </div>
            )}

            {user && invitation.registrationOpen && !invitation.alreadyAccepted && (
                <button
                    onClick={handleAccept}
                    disabled={accepting}
                    style={{padding: "8px 20px", fontSize: 15, cursor: "pointer", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: 4}}
                >
                    {accepting ? "Wird angenommen..." : "Einladung annehmen"}
                </button>
            )}
        </div>
    );
};

export default InvitationPage;
